module.exports = __webpack_public_path__ + "img/pic.c6061de4.png";